// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LockScreenModal.module.css */

:root {
  --green: rgba(24, 115, 70, 1);
  --green-soft: rgba(24, 115, 70, 0.12);
  --green-border: rgba(255, 255, 255, 0.55);
}

.LockScreenModal_overlay__yrMyv {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: #fff;
  display: flex;
  flex-direction: column;
}

/* top bar */
.LockScreenModal_topBar__nu2R- {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  border-bottom: 1px solid #eef2f7;
}

.LockScreenModal_brandLeft__djbeq {
  display: flex;
  align-items: center;
  gap: 10px;
}

.LockScreenModal_brandLogo__QZGvH {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: var(--green);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
}

.LockScreenModal_brandTitle__xD5bs {
  font-weight: 800;
}

.LockScreenModal_brandSub__l\\+Pua {
  font-size: 12px;
  color: #6b7280;
}

/* center */
.LockScreenModal_content__wMgeV {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.LockScreenModal_centerWrap__PkB\\+L {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.LockScreenModal_centerBlock__nFDmW {
  text-align: center;
}

.LockScreenModal_dotsRow__1-f-P {
  display: flex;
  justify-content: center;
  gap: 18px;
  margin-bottom: 12px;
}

.LockScreenModal_dot__\\+jTxv {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: 2px solid var(--green);
  background: transparent;
  transition: 0.15s ease;
}

.LockScreenModal_dotFilled__JHIfe {
  background: var(--green);
}

.LockScreenModal_hint__4EwY- {
  color: #6b7280;
  font-size: 14px;
}

.LockScreenModal_error__fR2o1 {
  margin-top: 10px;
  color: #ef4444;
  font-weight: 700;
}

/* keypad zone */
.LockScreenModal_keypadZone__RAFsU {
  background: var(--green);
  padding: 40px 0 60px;
  display: flex;
  justify-content: center;
}

.LockScreenModal_keypad__lkxOe {
  width: 320px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.LockScreenModal_key__VHEtv {
  height: 68px;
  border-radius: 8px;
  border: 1px solid var(--green-border);
  background: transparent;
  color: #fff;
  font-size: 22px;
  font-weight: 800;
  cursor: pointer;
  transition: 0.15s ease;

  /* 🔥 центрирование цифр */
  display: flex;
  align-items: center;
  justify-content: center;
}


.LockScreenModal_keyDisabledDot__HV3-L {
  cursor: default;
  opacity: 0.25;
}

.LockScreenModal_resetBtn__J9\\+eD {
  grid-column: 1 / -1;
  margin-top: 10px;
  height: 48px;
  border-radius: 8px;
  border: 1px solid var(--green-border);
  background: var(--green-soft);
  color: #fff;
  font-weight: 800;
  cursor: pointer;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/LockScreenModal.module.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;;EAEtB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* LockScreenModal.module.css */\n\n:root {\n  --green: rgba(24, 115, 70, 1);\n  --green-soft: rgba(24, 115, 70, 0.12);\n  --green-border: rgba(255, 255, 255, 0.55);\n}\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 99999;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n}\n\n/* top bar */\n.topBar {\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 18px;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.brandLeft {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.brandLogo {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  background: var(--green);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n}\n\n.brandTitle {\n  font-weight: 800;\n}\n\n.brandSub {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* center */\n.content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.centerWrap {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.centerBlock {\n  text-align: center;\n}\n\n.dotsRow {\n  display: flex;\n  justify-content: center;\n  gap: 18px;\n  margin-bottom: 12px;\n}\n\n.dot {\n  width: 34px;\n  height: 34px;\n  border-radius: 999px;\n  border: 2px solid var(--green);\n  background: transparent;\n  transition: 0.15s ease;\n}\n\n.dotFilled {\n  background: var(--green);\n}\n\n.hint {\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.error {\n  margin-top: 10px;\n  color: #ef4444;\n  font-weight: 700;\n}\n\n/* keypad zone */\n.keypadZone {\n  background: var(--green);\n  padding: 40px 0 60px;\n  display: flex;\n  justify-content: center;\n}\n\n.keypad {\n  width: 320px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.key {\n  height: 68px;\n  border-radius: 8px;\n  border: 1px solid var(--green-border);\n  background: transparent;\n  color: #fff;\n  font-size: 22px;\n  font-weight: 800;\n  cursor: pointer;\n  transition: 0.15s ease;\n\n  /* 🔥 центрирование цифр */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.keyDisabledDot {\n  cursor: default;\n  opacity: 0.25;\n}\n\n.resetBtn {\n  grid-column: 1 / -1;\n  margin-top: 10px;\n  height: 48px;\n  border-radius: 8px;\n  border: 1px solid var(--green-border);\n  background: var(--green-soft);\n  color: #fff;\n  font-weight: 800;\n  cursor: pointer;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `LockScreenModal_overlay__yrMyv`,
	"topBar": `LockScreenModal_topBar__nu2R-`,
	"brandLeft": `LockScreenModal_brandLeft__djbeq`,
	"brandLogo": `LockScreenModal_brandLogo__QZGvH`,
	"brandTitle": `LockScreenModal_brandTitle__xD5bs`,
	"brandSub": `LockScreenModal_brandSub__l+Pua`,
	"content": `LockScreenModal_content__wMgeV`,
	"centerWrap": `LockScreenModal_centerWrap__PkB+L`,
	"centerBlock": `LockScreenModal_centerBlock__nFDmW`,
	"dotsRow": `LockScreenModal_dotsRow__1-f-P`,
	"dot": `LockScreenModal_dot__+jTxv`,
	"dotFilled": `LockScreenModal_dotFilled__JHIfe`,
	"hint": `LockScreenModal_hint__4EwY-`,
	"error": `LockScreenModal_error__fR2o1`,
	"keypadZone": `LockScreenModal_keypadZone__RAFsU`,
	"keypad": `LockScreenModal_keypad__lkxOe`,
	"key": `LockScreenModal_key__VHEtv`,
	"keyDisabledDot": `LockScreenModal_keyDisabledDot__HV3-L`,
	"resetBtn": `LockScreenModal_resetBtn__J9+eD`
};
export default ___CSS_LOADER_EXPORT___;
